import { fetch } from '@utils/utils';
import * as T from '@modules/dogs/_dogsTypes';

export const getDog = ({ addError }) => async (id: string): Promise<T.Dog> => {
  try {
    const response: any = await fetch(`/metropolis/api/dg/dogs/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Dog = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const putDog = ({ addError, addSuccess }) => async body => {
  try {
    const response: any = await fetch(`/metropolis/api/dg/dogs/${body.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });
    addSuccess();
    const json = await response.json();
    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const searchDogs = ({ addError, addSuccess }) => async body => {
  try {
    const response: any = await fetch(`/metropolis/api/dg/dogs/register/search`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });
    const dogs = await response.json();
    addSuccess(`Počet nalezených psů: ${dogs.length}`);
    return dogs;
  } catch (err) {
    addError(err.message);
    return [];
  }
};

export const saveDogs = ({ addError }) => async body => {
  try {
    const response: any = await fetch(`/metropolis/api/dg/dogs/register/save`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });
    if (response.ok) {
      const dogs = await response.json();
      return dogs;
    } else {
      addError('Při ukládání psů došlo k chybě');
    }
    return response.ok;
  } catch (err) {
    addError(err.message);
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/dogs/_dogsActions.ts